import React from 'react';
import ReactDOM from 'react-dom/client';
import { SnackbarProvider } from 'notistack'; // Импорт SnackbarProvider
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SnackbarProvider maxSnack={3} // Максимальное количество одновременно отображаемых уведомлений
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right', // Уведомления появятся в правом верхнем углу
      }}
    >
      <App />
    </SnackbarProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();